export default "__VITE_ASSET__DysSvJd1__"